import { Button, Card, Checkbox, Col, Form, Input, Layout, Row, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import AppLogo from '../../../components/layout/AppLogo';
import AppFooter from '../../../components/layout/AppFooter';
import '../../../styles/styles.less';
import { useDispatch } from 'react-redux';
import { useLoginMutation } from '../../../app/api/authApiSlice';
import { setCredentials } from '../../../app/store/authSlice';
import React from 'react';

interface Credential {
  email: string;
  password: string;
  rememberMe: boolean;
}

const Login: React.FC = () => {
  const navigate = useNavigate();

  const [login, { isLoading }] = useLoginMutation();
  const dispatch = useDispatch();

  const handleLogin = ({ email, password, rememberMe }: Credential): void => {
    void (async () => {
      try {
        const userData = await login({ email, password }).unwrap();
        dispatch(
          setCredentials({ token: userData.accessToken, user: email, rememberMe: rememberMe }),
        );
        navigate('/');
      } catch (error: any) {
        // console.log(error)
      }
    })();
  };

  return (
    <Layout>
      <Layout.Content>
        <Row justify='center' align='middle' style={{ minHeight: '100vh' }}>
          <Col xs={20} sm={16} md={12} lg={10} xl={6} xxl={6}>
            <Card>
              <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
                <Row justify='center'>
                  <AppLogo size={128} />
                </Row>
                <Row justify='center'>
                  <Typography.Title level={5}>Admin Portal</Typography.Title>
                </Row>
                <Form
                  name='login'
                  initialValues={{ rememberMe: true }}
                  onFinish={handleLogin}
                  autoComplete='off'
                  layout='vertical'
                >
                  <Form.Item
                    name='email'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your email address!',
                      },
                    ]}
                  >
                    <Input placeholder='email address' />
                  </Form.Item>
                  <Form.Item
                    name='password'
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder='Password' />
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 32 }}>
                    <Button type='primary' htmlType='submit' block loading={isLoading}>
                      Log In
                    </Button>
                    <Button
                      type='link'
                      onClick={() => navigate('/forgot-password')}
                      style={{ float: 'right' }}
                    >
                      Forgot Password?
                    </Button>
                  </Form.Item>
                  <Form.Item name='rememberMe' valuePropName='checked' wrapperCol={{ span: 16 }}>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>
                </Form>
              </Space>
            </Card>
            <AppFooter />
          </Col>
        </Row>
      </Layout.Content>
    </Layout>
  );
};

export default Login;
